/* PrimerDeck — digital-products terms consent.
 * Injects an "I agree" checkbox into every cart checkout area (cart page +
 * cart drawer) and blocks the checkout buttons until it is ticked. Also adds
 * a small consent notice under product-page buy buttons (Buy now / wallets).
 * Consent is remembered per browser tab (sessionStorage), so it survives
 * drawer re-renders and page navigation within the visit.
 */
(function () {
  'use strict';
  if (window.pdTermsInit) return;
  window.pdTermsInit = true;

  var KEY = 'pd_terms_ok';
  // 02-09 (P0-5): teksten + policy-links komen uit Liquid (locale-keys pd.cart_terms.*,
  // routes.root_url) zodat de wettelijke instemming in de taal van de koper staat.
  var C = window.pdTermsCopy || {};
  var TERMS_URL = C.termsUrl || '/policies/terms-of-service';
  var REFUND_URL = C.refundUrl || '/policies/refund-policy';
  var LINKS_HTML =
    '<a href="' + TERMS_URL + '" target="_blank" rel="noopener">' + (C.terms || 'Terms') + '</a> &amp; ' +
    '<a href="' + REFUND_URL + '" target="_blank" rel="noopener">' + (C.refund || 'Refund Policy') + '</a>';
  var LABEL_TPL = C.label || 'I agree to the [links]: instant digital delivery, no 14-day right of withdrawal.';
  var NOTE_TPL = C.note || 'By purchasing you agree to the [links]: instant digital delivery, no 14-day right of withdrawal.';
  var LABEL_HTML = LABEL_TPL.replace('[links]', LINKS_HTML);
  var NOTE_HTML = NOTE_TPL.replace('[links]', LINKS_HTML);
  var ERROR_TEXT = C.error || 'Please tick the box above to continue to checkout.';

  function hasConsent() {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      return window.pdTermsOk === true;
    }
  }

  // 06-09 (doc 49 A1): de checkout-function weigert een checkout zonder attribuut. Daarom
  // ontgrendelen we pas als Shopify het attribuut bevestigd heeft; anders won een snelle
  // klik op "Checkout" het van de cart-update en zag de koper een foutmelding.
  var pending = false;
  function setConsent(v) {
    if (!v) {
      try { sessionStorage.setItem(KEY, '0'); } catch (e) { window.pdTermsOk = false; }
      sync();
      recordConsent(false);
      return Promise.resolve(false);
    }
    pending = true;
    sync();
    return recordConsent(true).then(function (ok) {
      pending = false;
      if (ok) {
        try { sessionStorage.setItem(KEY, '1'); } catch (e) { window.pdTermsOk = true; }
      } else {
        try { sessionStorage.setItem(KEY, '0'); } catch (e) { window.pdTermsOk = false; }
        document.querySelectorAll('.cart__ctas').forEach(showError);
      }
      sync();
      return ok;
    });
  }

  // 02-09 (audit P3-13 / chargeback-les): de instemming ook als cart-attribuut
  // vastleggen. Cart-attributen gaan mee naar de order (admin + bevestigingsmail)
  // en vormen zo het "duurzame drager"-bewijs (art. 8 lid 7 richtlijn 2011/83)
  // dat de koper uitdrukkelijk instemde met directe levering zonder herroepingsrecht.
  var ATTR = 'Digital delivery consent';
  function recordConsent(v) {
    var value = v ? (new Date().toISOString() + ' ' + (document.documentElement.lang || 'en') + ' ' + location.pathname) : '';
    var attrs = {};
    attrs[ATTR] = value;
    try {
      return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) {
        if (!r.ok) return false;
        return r.json().then(function (cart) {
          var got = cart && cart.attributes ? (cart.attributes[ATTR] || '') : '';
          return v ? got === value : got === '';
        }).catch(function () { return false; });
      }).catch(function () { return false; });
    } catch (e) {
      return Promise.resolve(false);
    }
  }

  var uid = 0;
  function buildTermsBox() {
    uid += 1;
    var id = 'pd-terms-checkbox-' + uid;
    var box = document.createElement('div');
    box.className = 'pd-cart-terms';
    box.setAttribute('data-pd-cart-terms', '');
    box.innerHTML =
      '<label class="pd-cart-terms__label" for="' + id + '">' +
      '<input type="checkbox" id="' + id + '" class="pd-cart-terms__checkbox">' +
      '<span class="pd-cart-terms__text">' + LABEL_HTML + '</span>' +
      '</label>' +
      '<span class="pd-cart-terms__error" role="alert" hidden>' + ERROR_TEXT + '</span>';
    return box;
  }

  // 13-09 (onderzoek A §7): het vinkje hoort alleen bij een wagen met minstens een DIGITALE regel.
  // Een puur fysieke wagen (fan shop) heeft gewoon bedenktijd en mag niet om afstand vragen; de
  // validation function vraagt dan ook niets. We lezen dat uit /cart.js (requires_shipping per
  // regel) en onthouden het kort; bij twijfel (fetch mislukt) tonen we het vinkje wel, want een
  // vinkje te veel is een ongemak, een vinkje te weinig een geweigerde checkout.
  var cartDigital = null;
  function checkDigital() {
    try {
      return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !Array.isArray(cart.items)) return true;
          return cart.items.some(function (it) { return it.requires_shipping === false && !it.gift_card; });
        }).catch(function () { return true; });
    } catch (e) { return Promise.resolve(true); }
  }

  function inject() {
    // Checkbox in every cart CTA container (cart page + cart drawer).
    var ctasAll = document.querySelectorAll('.cart__ctas');
    if (!ctasAll.length) return;
    checkDigital().then(function (digital) {
      cartDigital = digital;
      ctasAll.forEach(function (ctas) {
        var btn = ctas.querySelector('.cart__checkout-button');
        if (!btn || btn.hasAttribute('disabled')) return;
        var bestaand = ctas.querySelector('[data-pd-cart-terms]');
        if (!digital) { if (bestaand) bestaand.remove(); return; }
        if (!bestaand) ctas.insertBefore(buildTermsBox(), ctas.firstChild);
      });
      sync();
    });
    // 02-09 (audit P2-11): de extra JS-notitie onder de koopknoppen is weg. Het
    // vertaalbare blok `blocks.eu_withdrawal_html` (blocks/buy-buttons.liquid) staat
    // er al; twee bijna identieke wettelijke zinnen onder elkaar lazen als een fout.
    // 06-09 (doc 49 A1): deze checkbox is de gebruiksvriendelijke laag, niet het slot.
    // Het slot is de Cart & Checkout Validation Function (pd-consent-validation) die
    // de checkout weigert zolang het cart-attribuut ontbreekt.
  }

  function clearError(box) {
    box.classList.remove('pd-cart-terms--error');
    var err = box.querySelector('.pd-cart-terms__error');
    if (err) err.hidden = true;
  }

  function showError(ctas) {
    var box = ctas.querySelector('[data-pd-cart-terms]');
    if (!box) return;
    box.classList.add('pd-cart-terms--error');
    var err = box.querySelector('.pd-cart-terms__error');
    if (err) err.hidden = false;
    var cb = box.querySelector('.pd-cart-terms__checkbox');
    if (cb) {
      try { cb.focus(); } catch (e) { /* noop */ }
    }
  }

  function sync() {
    inject();
    var agreed = hasConsent();
    // Het vinkje toont wat de koper deed (ook tijdens het wachten op Shopify);
    // de vergrendeling gaat pas open als het attribuut bevestigd is.
    var checked = agreed || pending;
    var ok = agreed && !pending;
    document.querySelectorAll('[data-pd-cart-terms]').forEach(function (box) {
      var cb = box.querySelector('.pd-cart-terms__checkbox');
      if (cb && cb.checked !== checked) cb.checked = checked;
      var ctas = box.closest('.cart__ctas');
      if (ctas) ctas.classList.toggle('pd-terms-locked', !ok);
      if (ok) clearError(box);
    });
    document.querySelectorAll('.cart__ctas .cart__checkout-button').forEach(function (btn) {
      var locked = btn.closest('.pd-terms-locked') !== null;
      if (locked) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('pd-cart-terms__checkbox')) {
      setConsent(t.checked);
    }
  });

  // Block clicks on locked checkout areas. Wallet buttons get
  // pointer-events: none via CSS, so their clicks land on the container too.
  document.addEventListener('click', function (e) {
    if (hasConsent()) return;
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-pd-cart-terms]')) return;
    var ctas = e.target.closest('.cart__ctas.pd-terms-locked');
    if (!ctas) return;
    e.preventDefault();
    e.stopPropagation();
    showError(ctas);
  }, true);

  // Safety net for keyboard/form submits.
  document.addEventListener('submit', function (e) {
    if (hasConsent()) return;
    var s = e.submitter;
    if (s && s.name === 'checkout' && s.closest('.cart__ctas.pd-terms-locked')) {
      e.preventDefault();
      e.stopPropagation();
      showError(s.closest('.cart__ctas'));
    }
  }, true);

  // Re-apply after the theme re-renders cart sections (drawer updates, morphs).
  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  });

  function start() {
    sync();
    // Een cart kan intussen vervangen zijn (verlopen, samengevoegd na inloggen); dan mist het
    // attribuut terwijl de tab denkt dat er is ingestemd. Opnieuw zetten is idempotent.
    if (hasConsent()) setConsent(true);
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
